'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useEffect, useRef, useCallback } from 'react';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { useIsPopNavigation } from 'commons/navState';
import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import useFilterTransitionState from '../../hooks/useFilterTransitionState';
import AdvancedSearchProductsGrid from '../AdvancedSearchProductsGrid';
import LoadMoreButton from '../AdvancedSearchProductsGrid/LoadMoreButton';
import useHitsAccumulation from './hooks/useHitsAccumulation';
import useDisplayProducts from './hooks/useDisplayProducts';
import useScrollPersistence from './hooks/useScrollPersistence';
const AdvancedSearchProductHits = t0 => {
  const $ = _c(66);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onProductsChange
  } = t1;
  const {
    items,
    isLastPage,
    showMore
  } = useHitsAccumulation();
  const {
    results,
    status,
    setIndexUiState,
    indexUiState
  } = useInstantSearch();
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const mobileColumnCount = useMobileColumnCount();
  const {
    isReadyToShipActive,
    minWidth,
    maxWidth,
    activeTypeFilter,
    pagesUrlParam,
    updateUrlParamImmediate
  } = useAdvancedSearchContext();
  const isPopNavigation = useIsPopNavigation();
  let t2;
  if ($[2] !== isPopNavigation) {
    t2 = isPopNavigation();
    $[2] = isPopNavigation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isPopRef = useRef(t2);
  const scrollRestoredRef = useRef(false);
  const targetPagesRef = useRef(pagesUrlParam);
  let t3;
  let t4;
  if ($[4] !== activeTypeFilter || $[5] !== setIndexUiState) {
    t3 = () => {
      setIndexUiState(prev => {
        const currentType = prev?.refinementList?.type?.[0] ?? null;
        if (currentType === activeTypeFilter) {
          return prev;
        }
        const newRefinementList = {
          ...(prev.refinementList || {})
        };
        if (activeTypeFilter) {
          newRefinementList.type = [activeTypeFilter];
        } else {
          delete newRefinementList.type;
        }
        return {
          ...prev,
          refinementList: newRefinementList
        };
      });
    };
    t4 = [activeTypeFilter, setIndexUiState];
    $[4] = activeTypeFilter;
    $[5] = setIndexUiState;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  const currentPageCount = Math.ceil((items?.length || 0) / NUMBER_OF_PRODUCTS_TO_SHOW);
  let t5;
  if ($[8] !== currentPageCount || $[9] !== isLastPage || $[10] !== items?.length || $[11] !== showMore || $[12] !== status) {
    t5 = () => {
      if (status !== "idle" || !items?.length || isLastPage) {
        return;
      }
      if (currentPageCount - 1 < targetPagesRef.current) {
        showMore();
      }
    };
    $[8] = currentPageCount;
    $[9] = isLastPage;
    $[10] = items?.length;
    $[11] = showMore;
    $[12] = status;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = items?.length;
  let t7;
  if ($[14] !== currentPageCount || $[15] !== isLastPage || $[16] !== showMore || $[17] !== status || $[18] !== t6) {
    t7 = [currentPageCount, status, t6, isLastPage, showMore];
    $[14] = currentPageCount;
    $[15] = isLastPage;
    $[16] = showMore;
    $[17] = status;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  useEffect(t5, t7);
  indexUiState?.refinementList;
  let t8;
  if ($[20] !== indexUiState?.refinementList || $[21] !== isReadyToShipActive || $[22] !== maxWidth || $[23] !== minWidth) {
    t8 = JSON.stringify({
      refinementList: indexUiState?.refinementList || {},
      isReadyToShipActive,
      minWidth,
      maxWidth
    });
    $[20] = indexUiState?.refinementList;
    $[21] = isReadyToShipActive;
    $[22] = maxWidth;
    $[23] = minWidth;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const filterStateKey = t8;
  let t9;
  if ($[25] !== activeTypeFilter || $[26] !== filterStateKey || $[27] !== items || $[28] !== setIndexUiState || $[29] !== status || $[30] !== updateUrlParamImmediate) {
    t9 = {
      filterStateKey,
      setIndexUiState,
      items,
      status,
      activeTypeFilter,
      updateUrlParamImmediate,
      isPopRef,
      scrollRestoredRef,
      targetPagesRef
    };
    $[25] = activeTypeFilter;
    $[26] = filterStateKey;
    $[27] = items;
    $[28] = setIndexUiState;
    $[29] = status;
    $[30] = updateUrlParamImmediate;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  const {
    isFilterTransitioning,
    hasSearchCompleted,
    showNoResults
  } = useFilterTransitionState(t9);
  let t10;
  if ($[32] !== items || $[33] !== results || $[34] !== searchBoxQuery) {
    t10 = {
      items,
      searchBoxQuery,
      results
    };
    $[32] = items;
    $[33] = results;
    $[34] = searchBoxQuery;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  const {
    displayProducts,
    loading,
    productIds,
    productIdsRaw
  } = useDisplayProducts(t10);
  const t11 = items?.length;
  let t12;
  if ($[36] !== currentPageCount || $[37] !== loading || $[38] !== productIds.length || $[39] !== productIdsRaw.length || $[40] !== status || $[41] !== t11) {
    t12 = {
      isPopRef,
      scrollRestoredRef,
      targetPagesRef,
      status,
      currentPageCount,
      itemsLength: t11,
      loading,
      productIdsLength: productIds.length,
      productIdsRawLength: productIdsRaw.length
    };
    $[36] = currentPageCount;
    $[37] = loading;
    $[38] = productIds.length;
    $[39] = productIdsRaw.length;
    $[40] = status;
    $[41] = t11;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  useScrollPersistence(t12);
  let t13;
  let t14;
  if ($[43] !== displayProducts || $[44] !== onProductsChange) {
    t13 = () => {
      if (onProductsChange && displayProducts?.length > 0) {
        onProductsChange(displayProducts);
      }
    };
    t14 = [displayProducts, onProductsChange];
    $[43] = displayProducts;
    $[44] = onProductsChange;
    $[45] = t13;
    $[46] = t14;
  } else {
    t13 = $[45];
    t14 = $[46];
  }
  useEffect(t13, t14);
  let t15;
  if ($[47] !== pagesUrlParam || $[48] !== showMore || $[49] !== updateUrlParamImmediate) {
    t15 = () => {
      const nextPages = pagesUrlParam + 1;
      showMore();
      targetPagesRef.current = nextPages;
      updateUrlParamImmediate?.({
        pages: nextPages
      });
    };
    $[47] = pagesUrlParam;
    $[48] = showMore;
    $[49] = updateUrlParamImmediate;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  const handleShowMore = t15;
  const isRefreshing = status === "loading" || status === "stalled" || loading;
  if (!items?.length) {
    const showSkeleton = status === "loading" || status === "stalled" || isFilterTransitioning || !hasSearchCompleted || !showNoResults;
    if (showSkeleton) {
      let t16;
      if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <ProductCardStaticPlaceholderGroup count={NUMBER_OF_PRODUCTS_TO_SHOW} />;
        $[51] = t16;
      } else {
        t16 = $[51];
      }
      let t17;
      if ($[52] !== mobileColumnCount) {
        t17 = <div className="md:space-y-8 md:mb-8 md:flex-1 min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t16}</ProductCardGridUI></div>;
        $[52] = mobileColumnCount;
        $[53] = t17;
      } else {
        t17 = $[53];
      }
      return t17;
    }
    let t16;
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
      $[54] = t16;
    } else {
      t16 = $[54];
    }
    return t16;
  }
  const t16 = isRefreshing ? "animate-pulse" : "";
  let t17;
  if ($[55] !== displayProducts) {
    t17 = displayProducts?.length > 0 && <AdvancedSearchProductsGrid products={displayProducts} />;
    $[55] = displayProducts;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== displayProducts?.length || $[58] !== handleShowMore || $[59] !== isLastPage || $[60] !== loading) {
    t18 = displayProducts?.length > 0 && !isLastPage && <div className="flex justify-center mt-8 mb-12"><LoadMoreButton onClick={handleShowMore} isLoading={loading} /></div>;
    $[57] = displayProducts?.length;
    $[58] = handleShowMore;
    $[59] = isLastPage;
    $[60] = loading;
    $[61] = t18;
  } else {
    t18 = $[61];
  }
  let t19;
  if ($[62] !== t16 || $[63] !== t17 || $[64] !== t18) {
    t19 = <div className={t16}>{t17}{t18}</div>;
    $[62] = t16;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  return t19;
};
export default AdvancedSearchProductHits;